import type {} from "@lit/react";
import { BoardRow as BoardRowElement, } from "@vaadin/board/vaadin-board-row.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { BoardRowElement, };
export type BoardRowEventMap = Readonly<{}>;
const events = {} as BoardRowEventMap;
export type BoardRowProps = WebComponentProps<BoardRowElement, BoardRowEventMap>;
export const BoardRow = createComponent({
    elementClass: BoardRowElement, events, react: React, tagName: "vaadin-board-row"
});
